import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Side-effect import: initialises i18next before the first render so the
// detected language is already resolved by the time any component calls t().
import './i18n';
import App from './App';

// Wait for DOM to be ready
const container = document.getElementById('root');

if (!container) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);